export const LOAD_VOTES = 'votes/LOAD_VOTES';
export const UPVOTE = 'votes/UPVOTE';
export const DOWNVOTE = 'votes/DOWNVOTE';
export const SADVOTE = 'votes/SADVOTE';
export const FAVORITE = 'votes/FAVORITE';

export const DO_UPVOTE = 'votes/DO_UPVOTE';
export const DO_DOWNVOTE = 'votes/DO_DOWNVOTE';
export const DO_SADVOTE = 'votes/DO_SADVOTE';
export const DO_FAVORITE_START = 'votes/DO_FAVORITE_START';
export const DO_FAVORITE_COMPLETE = 'votes/DO_FAVORITE_COMPLETE';
